export default __webpack_public_path__ + "static/bagisto-28c11584966520e6f3384b67ecf98cc5.png";